// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mw-25[data-v-387b93e5] {\r\n  min-width: 25px;\n}\r\n", ""]);
// Exports
module.exports = exports;
